import { useState } from "react";
import { Box, InlineStack, Text, Button, Divider } from "@shopify/polaris";
import { useTranslation } from "../hooks/useTranslation";
import { PrivacyPolicyModal } from "./modals/PrivacyPolicyModal";
import { TermsOfServiceModal } from "./modals/TermsOfServiceModal";
import { SupportModal } from "./modals/SupportModal";
import { DocumentationModal } from "./modals/DocumentationModal";

export default function AppFooter() {
  const { t } = useTranslation();

  // Modal visibility state
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [docsOpen, setDocsOpen] = useState(false);

  return (
    <>
      <Divider />
      <Box paddingBlock="400">
        <InlineStack gap="400" align="center" blockAlign="center" wrap={true}>
          {/* Copyright and Version */}
          <InlineStack gap="200" align="start">
            <Text as="span" variant="bodySm" tone="subdued">
              {t("footer.copyright")}
            </Text>
            <Text as="span" variant="bodySm" tone="subdued">
              •
            </Text>
            <Text as="span" variant="bodySm" tone="subdued">
              v{__APP_VERSION__}
            </Text>
            <Text as="span" variant="bodySm" tone="subdued">
              •
            </Text>
          </InlineStack>
          <InlineStack gap="300" wrap={true}>
            <Button
              variant="plain"
              onClick={() => setPrivacyOpen(true)}
              size="slim"
            >
              {t("footer.privacy")}
            </Button>

            <Button
              variant="plain"
              onClick={() => setTermsOpen(true)}
              size="slim"
            >
              {t("footer.terms")}
            </Button>

            <Button
              variant="plain"
              onClick={() => setSupportOpen(true)}
              size="slim"
            >
              {t("footer.support")}
            </Button>

            <Button
              variant="plain"
              onClick={() => setDocsOpen(true)}
              size="slim"
            >
              {t("footer.documentation")}
            </Button>
          </InlineStack>
        </InlineStack>
      </Box>

      {/* Modals */}
      <PrivacyPolicyModal
        open={privacyOpen}
        onClose={() => setPrivacyOpen(false)}
      />

      <TermsOfServiceModal
        open={termsOpen}
        onClose={() => setTermsOpen(false)}
      />

      <SupportModal
        open={supportOpen}
        onClose={() => setSupportOpen(false)}
      />

      <DocumentationModal
        open={docsOpen}
        onClose={() => setDocsOpen(false)}
      />
    </>
  );
}
